import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AccountCtx = createContext(null);
export const useAccount = () => useContext(AccountCtx);

export function AccountAuthProvider({ children }) {
  // user: null = checking, false = not authenticated, object = authenticated
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("ic_user_token") || "");

  const save = (tk, u) => { localStorage.setItem("ic_user_token", tk); setToken(tk); setUser(u); };
  const logout = useCallback(() => { localStorage.removeItem("ic_user_token"); setToken(""); setUser(false); }, []);

  const checkAuth = useCallback(async () => {
    const tk = localStorage.getItem("ic_user_token");
    if (!tk) { setUser(false); return; }
    try {
      const { data } = await axios.get(`${API}/account/me`, { headers: { Authorization: `Bearer ${tk}` } });
      setUser(data.user);
    } catch (e) {
      localStorage.removeItem("ic_user_token"); setToken(""); setUser(false);
    }
  }, []);

  useEffect(() => {
    // Skip auto-check while a Google callback is being processed
    if (window.location.hash?.includes("session_id=")) { return; }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/account/login`, { email, password });
    save(data.access_token, data.user); return data.user;
  };
  const register = async (payload) => {
    const { data } = await axios.post(`${API}/account/register`, payload);
    save(data.access_token, data.user); return data.user;
  };
  const googleExchange = async (session_id) => {
    const { data } = await axios.post(`${API}/account/google`, { session_id });
    save(data.access_token, data.user); return data.user;
  };

  return (
    <AccountCtx.Provider value={{ user, token, login, register, googleExchange, logout, refresh: checkAuth, authHeader: token ? { Authorization: `Bearer ${token}` } : {} }}>
      {children}
    </AccountCtx.Provider>
  );
}
